<div class="widget form-group" [class.has-error]="control.invalid">
  <label [attr.for]="id" class="horizontal control-label">
    {{ schema.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <textarea [attr.readonly]="schema.readOnly" [name]="name"
    class="text-widget textarea-widget form-control"
    [attr.placeholder]="schema.placeholder"
    [attr.maxLength]="schema.maxLength || null"
    [attr.minLength]="schema.minLength || null"
    [formControl]="control"></textarea>
  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/textarea.widget.html